export function showNavDrops() {    
    const $items = $(".main-menu > li");
    const $body = $("body");

    $(window).on("load resize", () => {
        initDropdown();
    });
    
    $(document).on("click", ".main-menu > .extendable", function () {
        if ( $(window).width() < 1200 ) {
            if ( !$(this).hasClass("current") ) {
                // closeAllMobileDropdowns();
                $(this)
                    .addClass("current")
                    .find("ul").stop().slideDown();
            } else {
                closeAllMobileDropdowns();
            }
        } else {
            if ( !$(this).hasClass("current") ) {
                closeAllDesktopDropdowns();
                $(this).addClass("current");
            } else {
                closeAllDesktopDropdowns();
            }
        }
    });
    
    $(document).on("click", (evt) => {
        if ( $(window).width() >= 1200 && !$(evt.target).closest(".dropdown, .main-menu > li > button").length ) {
            closeAllDesktopDropdowns();
        }
    });
    
    function initDropdown() {
        if ( $body.hasClass("touch") ) {
            $items.each((i, it) => {
                if ( $(it).find("ul").length && !$(it).find("button").length ) {
                    $(it).addClass("extendable");
                    console.log($(it));
                }
            });
        }
    }
    
    function closeAllMobileDropdowns() {
        $items.each((i, it) => {
            if ( $(it).hasClass("current") ) {
                $(it)
                    .removeClass("current")
                    .find("ul").stop().slideUp();
            }
        });
    }
    
    function closeAllDesktopDropdowns() {
        $items.each((i, it) => {
            if ( $(it).hasClass("current") ) {
                $(it).removeClass("current");
            }
        });
    }

}


// WEBPACK FOOTER //
// ./assets/js/modules/show-navigation-dropdowns.js